import { CallApi, handleJSONResponse } from './common';
import {
  startUpload,
  uploadToS3,
  UploadResponse,
  UploadStartRequest,
} from './upload';

const callAPI = CallApi('assets');

export interface AssetUploadResponse extends UploadResponse {
  id: string;
  mediumImageUrl: string;
  smallImageUrl: string;
}

export interface AssetUploadStartRequest extends UploadStartRequest {
  id?: string;
  type: string;
}

export const upload = async (
  type: string,
  file: File,
  signal?: AbortSignal
): Promise<AssetUploadResponse> => {
  const form: AssetUploadStartRequest = {
    type,
    filename: file.name,
    contentType: file.type,
  };

  const { formData, ...data } = await startUpload<
    AssetUploadStartRequest,
    AssetUploadResponse
  >(form, callAPI, '/upload', signal);
  return {
    ...data,
    upload: uploadToS3(file, formData),
  };
};

export const replace = async (
  id: string,
  type: string,
  file: File,
  signal?: AbortSignal
): Promise<AssetUploadResponse> => {
  const form: AssetUploadStartRequest = {
    type,
    id,
    filename: file.name,
    contentType: file.type,
  };

  const { formData, ...data } = await startUpload<
    AssetUploadStartRequest,
    AssetUploadResponse
  >(form, callAPI, '/upload', signal);
  return {
    ...data,
    upload: uploadToS3(file, formData),
  };
};

export const getStatus = async (category: string, ids: string[]) => {
  const response = await callAPI(`/status/${category}`, 'POST', ids);

  return handleJSONResponse(response);
};
